import { API_URL } from '../constants'
import { axiosInstance } from './axiosinstance'

const REGIONS_API_URL = `${API_URL}/api/v1/cti-regions`

export const loadRegionData = async () => {
  try {
    const response = await axiosInstance.get(REGIONS_API_URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })

    if (response.status != 200) {
      console.warn(
        `WARN: Couldn't load region data: '${response.status}':'${response.statusText}'`
      )
      return []
    }

    const json = await response.data

    return json
  } catch (error) {
    console.warn("WARN: Couldn't load region data: '" + error.message + "'")
    return []
  }
}
